@if (block.data.heading) {
    <section
        class="cta-banner-container-background"
        [style]="`
    --bg: ${getBg()};
    --bg-blend-mode: ${block.data.useBgBlendColor ? block.data.bgBlendMode : undefined};
    --text-color: ${block.data.textColor};
    `"
        [style.background-color]="block.data.useBgBlendColor ? getBgColor(block.data.bgBlendColor) : undefined">
        <div class="container cta-banner-container">
            <!-- Optional left image -->
            @if (block.data.includeFgImage) {
                <div class="cta-banner__image-container">
                    <img class="cta-banner__image" [src]="parseImageUrl(block.data.fgImage)" alt="" />
                </div>
            }

            <div class="cta-banner__content">
                <h2 class="cta-banner__heading">
                    {{ block.data.heading }}
                </h2>

                @if (block.data.subheading) {
                    <div class="cta-banner__subheading" [innerHTML]="block.data.subheading"></div>
                }

                @if (block.data.description) {
                    <div class="cta-banner__description" [innerHTML]="block.data.description"></div>
                }

                <a
                    class="btn btn-primary cta-banner__link"
                    [href]="block.data.ctaLink"
                    [target]="block.data.isCtaExternalLink ? '_blank' : '_self'"
                    [attr.aria-label]="block.data.includeAriaLabel ? block.data.ariaLabel : null">
                    <span [innerText]="block.data.ctaLabel | translate"></span>
                    <core-icon [name]="'arrow-right'"></core-icon>
                </a>
            </div>
        </div>
    </section>
}
